/* ==========================================================================
   Sticky add-to-cart bar — Basketeer PDP
   Pairs with snippets/sticky-atc-bar.liquid and assets/sticky-atc-bar.css.

   Design rule for this whole file: THE BAR NEVER COMPUTES ANYTHING. It reads the real product
   form's DOM and copies it. Price, label and disabled state are all mirrored, never re-derived —
   because Dawn re-renders the buy-buttons section over AJAX on every variant change, and a
   separate calculation here would drift from what the shopper is actually looking at.

   Silent failure is the bug: if the real button or the price element cannot be found, this aborts
   loudly and renders nothing. A missing bar is a non-event; a bar showing a stale price is not.
   ========================================================================== */

(function () {
  'use strict';

  var BARS = document.querySelectorAll('.bk-atc:not([data-bk-atc-init])');
  if (!BARS.length) return;

  Array.prototype.forEach.call(BARS, function (root) {
    root.setAttribute('data-bk-atc-init', '1');

    var sectionId = root.dataset.sectionId;
    if (!sectionId) {
      console.warn('[StickyAtc] no data-section-id on the bar — not initialising.');
      return;
    }

    var realBtn  = document.getElementById('ProductSubmitButton-' + sectionId);
    var priceBox = document.getElementById('price-' + sectionId);

    // Fail loudly, and do NOT fall back to a Liquid-rendered price. `product-options-selector`
    // rewrites the on-screen price client-side, so anything we render ourselves is wrong the
    // moment a paid option is picked. No price element means no bar.
    if (!realBtn) {
      console.warn('[StickyAtc] ProductSubmitButton-' + sectionId + ' not found — bar disabled.');
      return;
    }
    if (!priceBox) {
      console.warn('[StickyAtc] price-' + sectionId + ' not found — bar disabled rather than risk showing a stale price.');
      return;
    }

    var elVariant = root.querySelector('[data-bk-atc-variant]');
    var elPrice   = root.querySelector('[data-bk-atc-price]');
    var elThumb   = root.querySelector('[data-bk-atc-thumb]');
    var btn       = root.querySelector('[data-bk-atc-submit]');
    if (!btn) {
      console.warn('[StickyAtc] bar has no submit button — not initialising.');
      return;
    }

    /* ── relocate to <body> ───────────────────────────────────────────────────────────────────
       A custom_liquid block renders inside .product__info-wrapper. If "Reveal on scroll" is ever
       switched on in the theme editor, that wrapper gets a `transform`, and a transformed ancestor
       makes `position: fixed` resolve against the ancestor instead of the viewport — the bar would
       silently stop being pinned. Moving it to the end of <body> makes that impossible, and keeps
       the tab order natural (page content first, bar last). */
    document.body.appendChild(root);
    root.classList.add('bk-atc--ready');

    /* ── mirroring ─────────────────────────────────────────────────────────────────────────── */

    function syncPrice() {
      // The live text, whatever produced it. `.price-item--regular` is Dawn's element; if the
      // markup ever changes, fall back to the container's own text rather than showing nothing.
      var el = priceBox.querySelector('.price-item--regular') || priceBox;
      var txt = (el.textContent || '').trim();
      if (txt && elPrice) elPrice.textContent = txt;
    }

    function syncButton() {
      // Copy the real button verbatim — label AND disabled. Dawn's toggleSubmitButton
      // (assets/product-form.js) rewrites both, so mirroring is the only thing that cannot drift.
      var isDisabled = realBtn.hasAttribute('disabled');
      if (isDisabled) btn.setAttribute('disabled', '');
      else btn.removeAttribute('disabled');

      var span = realBtn.querySelector('span:not(.visually-hidden)');
      var label = ((span ? span.textContent : realBtn.textContent) || '').trim();
      if (label) btn.textContent = label;
    }

    function syncVariant() {
      // Absent entirely on single-variant products (product-variant-picker is wrapped in
      // `unless product.has_only_default_variant`), which is why the row starts hidden.
      var node = document.querySelector('variant-selects [data-selected-variant]');
      if (!node || !elVariant) return;
      try {
        var v = JSON.parse(node.textContent || node.innerHTML || 'null');
        if (!v) return;
        if (v.title) {
          elVariant.textContent = v.title;
          elVariant.hidden = false;
        }
        if (elThumb && v.featured_image && v.featured_image.src) {
          // Ask the CDN for the size we actually display rather than the full asset.
          elThumb.src = v.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1');
        }
      } catch (e) {
        console.warn('[StickyAtc] could not read the selected variant:', e.message);
      }
    }

    function syncAll() { syncPrice(); syncButton(); syncVariant(); }
    syncAll();

    /* ── show / hide ───────────────────────────────────────────────────────────────────────────
       Shown only once the real button has scrolled ABOVE the viewport. `boundingClientRect.top < 0`
       is what stops it appearing on load while the button is still below the fold. */
    var visible = false;
    function setVisible(on) {
      if (on === visible) return;
      visible = on;
      root.classList.toggle('bk-atc--on', on);
      document.body.classList.toggle('bk-atc-on', on);
      if (on) root.removeAttribute('inert');
      else root.setAttribute('inert', '');   // never in the tab order while hidden
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e) return;
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(realBtn);
    } else {
      // No observer: leave the bar hidden. The real button still works, and a permanently visible
      // duplicate is worse than none.
      console.warn('[StickyAtc] IntersectionObserver unsupported — bar stays hidden.');
    }

    /* ── keep it in step ───────────────────────────────────────────────────────────────────────
       Two mechanisms, deliberately. `variant-change` covers Dawn's own AJAX section re-render;
       the MutationObservers cover product-options-selector's price rewrite, which fires NO event
       at all — subscribing alone would leave the bar showing the pre-option price. */
    // ⛔ NOT `window.PUB_SUB_EVENTS`. assets/constants.js declares it as a top-level `const`, which
    // creates a global BINDING but no property on `window` — so `window.PUB_SUB_EVENTS` is
    // undefined and a guard written that way is permanently false, silently skipping this
    // subscription. `subscribe` is a function declaration, so that one does attach. Reference the
    // bare identifier behind `typeof`, which is safe even when it does not exist.
    var PSE = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null;
    if (typeof subscribe === 'function' && PSE && PSE.variantChange) {
      subscribe(PSE.variantChange, function (event) {
        if (event && event.data && String(event.data.sectionId) !== String(sectionId)) return;
        // The section swap replaces the nodes we hold, so re-resolve before reading.
        var fresh = document.getElementById('price-' + sectionId);
        if (fresh) priceBox = fresh;
        var freshBtn = document.getElementById('ProductSubmitButton-' + sectionId);
        if (freshBtn) realBtn = freshBtn;
        syncAll();
      });
    } else {
      // Say so. The MutationObservers below still cover price and button changes, but losing the
      // variant event means the thumbnail and variant NAME stop updating — worth knowing about
      // rather than discovering from a screenshot.
      console.warn('[StickyAtc] pubsub unavailable — variant name and thumbnail will not refresh.');
    }

    new MutationObserver(syncPrice).observe(priceBox, {
      childList: true, subtree: true, characterData: true
    });
    new MutationObserver(syncButton).observe(realBtn, {
      attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true
    });

    /* ── stand aside for the chat panel ────────────────────────────────────────────────────────
       Under 480px the panel is a full-width 85dvh sheet and the bar would be stranded behind it.
       CSS handles this via :has(); this is the fallback for engines without it. */
    var panel = document.querySelector('.bk-chat-panel');
    if (panel) {
      new MutationObserver(function () {
        document.body.classList.toggle('bk-atc-chat-open', panel.classList.contains('open'));
      }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
